// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lzR2p","col":"styles_col__zl4XP"};